import { render, staticRenderFns } from "./scheme-config.vue?vue&type=template&id=a73404e4&scoped=true"
import script from "./scheme-config.vue?vue&type=script&lang=js"
export * from "./scheme-config.vue?vue&type=script&lang=js"
import style0 from "./scheme-config.vue?vue&type=style&index=0&id=a73404e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73404e4",
  null
  
)

export default component.exports